import { Loader2 } from "lucide-react";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "components/ui/alert-dialog";

import { MONTHS_PT } from "../constants";
import { type MonthView, getMonthYear } from "../types";

interface BlockDialogProps {
  open: boolean;
  target: MonthView | null;
  isLoading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function BlockDialog({
  open,
  target,
  isLoading,
  onClose,
  onConfirm,
}: BlockDialogProps) {
  const label = target
    ? `${MONTHS_PT[getMonthYear(target).month - 1]}/${getMonthYear(target).year}`
    : "";

  return (
    <AlertDialog open={open} onOpenChange={(o) => !o && onClose()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Bloquear {label}?</AlertDialogTitle>
          <AlertDialogDescription>
            Analistas não poderão executar novas extrações para este período
            até que seja reaberto. Extrações já concluídas continuarão
            acessíveis.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoading}>Cancelar</AlertDialogCancel>
          <AlertDialogAction
            className="bg-red-600 hover:bg-red-700 text-white"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Bloquear Mês
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
